/**
 * The field that holds the currency of each ticket size field, in the same section or
 * the same row. A ticket size band such as `1 Mn - 3 Mn` has no meaning without it.
 */
export const TICKET_SIZE_CURRENCY_FIELD: Record<string, string> = {
  ticket_size: 'currency_ticket_size',
  fund_ticket_size: 'fund_ticket_size_currency',
}

/** Each ticket size band with the currency in front of it, for example `USD 1 Mn - 3 Mn` (F6). */
export function withCurrency(sizes: string[], currency: string | null | undefined): string[] {
  const code = currency?.trim()
  if (!code) return sizes
  return sizes.map((size) => (size.toLowerCase().startsWith(`${code.toLowerCase()} `) ? size : `${code} ${size}`))
}
